module.exports = "/legacy/45e478c236db9adba6b6f31c8021b996.svg";